// @generated
// AUTO-GENERATED by scripts/generate-fhir-terminologies.ts. Do not edit.
// Run: npm run generate:terminologies
// Source: apps/ig/input/resources/value-sets/supported-timezones.json
export const URL = 'http://alopexcare.com/fhir/ValueSet/supported-timezones';
export const concepts = [
    { code: 'Pacific/Honolulu', display: 'Hawaii (UTC-10)', displayUi: 'Hawaii (UTC-10)', system: 'https://www.iana.org/time-zones' },
    { code: 'America/Anchorage', display: 'Alaska (UTC-9)', displayUi: 'Alaska (UTC-9)', system: 'https://www.iana.org/time-zones' },
    { code: 'America/Los_Angeles', display: 'Pacific (UTC-8)', displayUi: 'Pacific (UTC-8)', system: 'https://www.iana.org/time-zones' },
    { code: 'America/Denver', display: 'Mountain (UTC-7)', displayUi: 'Mountain (UTC-7)', system: 'https://www.iana.org/time-zones' },
    { code: 'America/Chicago', display: 'Central (UTC-6)', displayUi: 'Central (UTC-6)', system: 'https://www.iana.org/time-zones' },
    { code: 'America/New_York', display: 'Eastern (UTC-5)', displayUi: 'Eastern (UTC-5)', system: 'https://www.iana.org/time-zones' },
    { code: 'America/Halifax', display: 'Atlantic (UTC-4)', displayUi: 'Atlantic (UTC-4)', system: 'https://www.iana.org/time-zones' },
    { code: 'America/St_Johns', display: 'Newfoundland (UTC-3:30)', displayUi: 'Newfoundland (UTC-3:30)', system: 'https://www.iana.org/time-zones' },
];
export function isValidCode(value) {
    return concepts.some((c) => c.code === value);
}
/** Returns the UI display (designation override if present, else canonical display). */
export function getDisplay(code) {
    return concepts.find((c) => c.code === code)?.displayUi ?? '';
}
/**
 * Build a FHIR Coding with the canonical display (NOT displayUi) to preserve
 * server-side terminology-binding validity. Use getDisplay() for UI rendering.
 */
export function toCoding(code) {
    const concept = concepts.find((c) => c.code === code);
    return { system: concept?.system ?? '', code, display: concept?.display ?? '' };
}
